<template>
  <div>
    <top-message />
    <div class="content">
      <div class="titlePart">草稿箱</div>
      <div style="border-top: 1px solid #f3f4f9">
        <div
          class="state"
          v-for="(item,index) in webList"
          :key="index"
        >
          <div class="stateDetails">
            <div>
              <!-- <div class="stateTextTop">企业征信信息采集和查询授权书</div> -->
              <div class="stateTextTop">{{ item.enterpriseName }}</div>
              <div class="stateTextBtn">
                保存时间：{{ item.creteTime &&$moment(item.creteTime).format("YYYY-MM-DD HH:mm:ss") }}
              </div>
            </div>
            <div class="rightPart">
              <el-steps
                :active="parseInt(item.status)"
                align-center
              >
                <el-step title="选择授权对象"></el-step>
                <el-step title="上传授权书"></el-step>
                <el-step title="上传经营执照"></el-step>
                <el-step title="上传经办人身份证"></el-step>
              </el-steps>
            </div>
            <div class="stateBtn">
              <el-button @click="getDelete(item.id)">删除</el-button>
              <el-button
                type="primary"
                @click="handleEdit(item.id)"
              >编辑</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { webAuthList, Delete } from '@/api/myCenter'
import TopMessage from "@/components/TopMessage";

export default {
  components: { TopMessage },
  data () {
    return {
      active: '',
      webList: [],
    }
  },
  created () {
    this.getWebAuth()
  },
  methods: {
    getWebAuth () {
      webAuthList().then(res => {
        res = this.paramDecrypt(res);
        this.webList = res.data
      })
    },
    getDelete (id) {
      Delete(id).then(res => {
        res = this.paramDecrypt(res);
        if (res.code === 200) {
          this.$message.success("删除成功")
          this.getWebAuth();
        }
      })
    },
    handleEdit (id) {
      this.$emit("send", "newAuth");
      this.$store.commit("setAuthId", id);
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  min-height: 740px;
  background: #fff;
  box-sizing: border-box;
  padding-top: 20px;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;

  .titlePart {
    color: #2981ee;
    font-size: 24px;
    font-weight: bold;
    border-left: 5px solid #2981ee;
    padding-left: 20px;
    margin-bottom: 20px;
  }

  .state {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;

    .stateDetails {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f3f4f9;
      padding-bottom: 20px;

      .rightPart {
        width: 60%;
        margin-top: 30px;
      }

      .stateTextTop {
        font-size: 20px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: #2a2a2a;
        white-space: nowrap;
      }

      .stateTextBtn {
        font-size: 16px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #252525;
        margin-top: 14px;
      }

      .stateBtn {
        display: flex;
      }
    }
  }
}

/deep/ .el-steps {
  .el-step__line-inner {
    border-color: #dbdbdb;
  }

  .el-step__icon {
    color: #fff;
    top: -5px;
    border-width: 5px;
    box-sizing: content-box;
  }

  .is-finish .el-step__icon {
    background: #44cb8e;
    border-color: #c7eedb;
  }

  .is-process .el-step__icon {
    background: #3498f2;
    border-color: #b9d4f2;
  }

  .is-wait .el-step__icon {
    background: #a7a7a7;
    border-color: #dbdbdb;
  }

  .el-step__title {
    font-size: 14px;
    font-weight: 540;
  }

  .el-step__title.is-finish {
    color: #44cb8e;
  }

  .el-step__title.is-process {
    //color: #a7a7a7;
    color: #3498f2;
  }

  .el-step__title.is-wait {
    color: #a7a7a7;
  }

  .el-step__description {
    padding-left: 10px !important;
    padding-right: 10px !important;
    color: #252525;
  }

  .cancelButton {
    color: #fff;
    font-size: 13px;
    padding: 4px 6px;
    background: #2981ee;
    border-radius: 4px;
    width: 30px;
    margin: 4px auto 0;
    cursor: pointer;
  }

  .rejectSpan {
    color: #f85b4b;
  }
}
</style>
